import Vue from 'vue'
import Router from 'vue-router'
// import LayoutBlank from '../views/layout/LayoutBlank'
const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import BlankLayout from '../views/layout/Blank'

/** note: submenu only apppear when children.length>=1
*   detail see  https://panjiachen.github.io/vue-element-admin-site/#/router-and-nav?id=sidebar
**/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export const constantRouterMap = [
  { path: '/login', name: 'login', component: _import('login/index'), hidden: true },
  { path: '/404', component: _import('errorPage/404'), hidden: true },
  { path: '/401', component: _import('errorPage/401'), hidden: true },
  { path: '/', component: Layout, redirect: '/platform/platformList' },
  { path: '/privacyPolicyHw', name: 'privacyPolicyHw', component: _import('staticPage/PrivacyPolicyHw'), hidden: true },
  { path: '/contactUs', name: 'contactUs', component: _import('staticPage/contactUs'), hidden: true },
  { path: '/aboutUs', name: 'aboutUs', component: _import('staticPage/aboutUs'), hidden: true },
  { path: '/staticPage', component: BlankLayout,
    children: [
      {
        path: 'Agreement', // 用户协议
        component: _import('staticPage/Agreement')
      },
      {
        path: 'PrivacyPolicy', // 公司隐私政策
        component: _import('staticPage/PrivacyPolicy')
      },
      {
        path: 'JiaoXin/PrivacyPolicy', // 交信 隐私政策
        component: _import('staticPage/JiaoXin/PrivacyPolicy')
      },
      {
        path: 'LinFen/PrivacyPolicy', // 临汾 隐私政策
        component: _import('staticPage/LinFen/PrivacyPolicy')
      },
      {
        path: 'LinFen/Agreement', // 临汾 用户协议
        component: _import('staticPage/LinFen/Agreement')
      },
      {
        path: 'MessageDetail/:mid', // 通知详情
        component: _import('staticPage/MessageDetail')
      }
    ]
  }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
// 注意children的path前面不加'/'
export const asyncRouterMap = [
  {
    component: Layout,
    path: '/sysOrg',
    meta: {
      title: 'sysOrg',
      icon: 'icon-jigouguanli',
      code: 'sysOrg'
    },
    children: [
      {
        path: 'sysOrg', // 机构管理
        component: _import('sysOrg/index'),
        name: 'sysOrg',
        meta: {
          title: 'sysOrg',
          icon: '',
          noCache: true,
          code: 'sysOrg'
        }
      }
    ]
  },
  {
    component: Layout,
    path: '/sys',
    meta: {
      title: 'sys', // 基础数据
      icon: 'icon-xitongshezhi',
      code: 'sys'
    },
    children: [
      {
        path: 'user', // 用户管理
        component: _import('sys/user/index'),
        name: 'user',
        meta: {
          title: 'user',
          icon: '',
          noCache: true,
          code: 'user'
        }
      },
      {
        path: 'role/index', // 角色管理
        component: _import('sys/role/index'),
        name: 'role',
        meta: {
          title: 'role',
          icon: '',
          noCache: true,
          code: 'role'
        }
      },
      {
        path: 'perm/index', // 权限管理
        component: _import('sys/perm/index'),
        name: 'sysPerm',
        meta: {
          title: 'perm',
          icon: '',
          noCache: true,
          code: 'perm'
        }
      },
      {
        path: 'sysDic', // 字典管理
        component: _import('sys/dic/index'),
        name: 'sysDic',
        meta: {
          title: 'sysDic',
          icon: '',
          noCache: true,
          code: 'sysDic'
        }
      },
      {
        path: 'logTranslate/index', // 系统字典
        component: _import('sys/logTranslate/index'),
        name: 'logTranslate',
        meta: {
          title: 'logTranslate',
          icon: '',
          noCache: true,
          code: 'logTranslate'
        }
      },
      {
        path: 'swipe/index', // 轮播图管理
        component: _import('sys/swipe/index'),
        name: 'swipe',
        meta: {
          title: 'swipe',
          icon: '',
          noCache: true,
          code: 'swipe'
        }
      },
      {
        path: 'sysLog/index', // 系统日志
        component: _import('sys/sysLog/index'),
        name: 'sysLog',
        meta: {
          title: 'sysLog',
          icon: '',
          noCache: true,
          code: 'sysLog'
        }
      }
    ]
  },
  {
    component: Layout,
    path: '/platform',
    meta: {
      title: 'platform', // 平台管理
      icon: 'icon-pingtaiguanli',
      code: 'platform'
    },
    children: [{
      path: 'platformList', // 平台列表
      component: _import('platform/platformList/index'),
      name: 'platformList',
      meta: {
        title: 'platformList',
        icon: '',
        noCache: true,
        code: 'platformList'
      }
    },
    {
      path: 'platformProd', // 平台商品
      component: _import('platform/platformProd/index'),
      name: 'platformProd',
      meta: {
        title: 'platformProd',
        icon: '',
        noCache: true,
        code: 'platformProd'
      }
    },
    {
      path: 'material', // 管理
      component: _import('platform/material/index'),
      name: 'material',
      meta: {
        title: 'material',
        icon: '',
        noCache: true,
        code: 'material'
      }
    },
    {
      path: 'clwPlatform', // 监控平台列表-车联网
      component: _import('platform/clwPlatform/index'),
      name: 'clwPlatform',
      meta: {
        title: 'clwPlatform',
        icon: '',
        noCache: true,
        code: 'clwPlatform'
      }
    }
    ]
  },
  /**
   * 新闻资讯管理
   */
  {
    component: Layout,
    path: '/news',
    meta: {
      title: 'news', // 新闻资讯模块
      icon: 'icon-hangqingzixun',
      code: 'news'
    },
    children: [{
      path: 'newsMessages', // 新闻资讯s
      component: _import('news/newsMessages/index'),
      name: 'newsMessages',
      meta: {
        title: 'newsMessages',
        icon: '',
        noCache: true,
        code: 'newsMessages'
      }
    },
    // {
    //   path: 'newsMessage', // 新闻资讯s
    //   component: _import('news/newsMessage/index'),
    //   name: 'newsMessage',
    //   meta: {
    //     title: 'newsMessage',
    //     icon: 'icon-jixieshebei',
    //     noCache: true,
    //     code: 'newsMessage'
    //   }
    // },
    // {
    //   path: 'policy', // 政策法规
    //   component: _import('news/policy/index'),
    //   name: 'policy',
    //   meta: {
    //     title: 'policy',
    //     icon: 'icon-jixieshebei',
    //     noCache: true,
    //     code: 'policy'
    //   }
    // },
    // {
    //   path: 'regionalNews', // 区域新闻
    //   component: _import('news/regionalNews/index'),
    //   name: 'regionalNews',
    //   meta: {
    //     title: 'regionalNews',
    //     icon: 'icon-jixieshebei',
    //     noCache: true,
    //     code: 'regionalNews'
    //   }
    // },
    {
      path: 'newsAuditRecord', // 审核
      component: _import('news/newsAuditRecord/index'),
      name: 'newsAuditRecord',
      meta: {
        title: 'newsAuditRecord',
        icon: '',
        noCache: true,
        code: 'newsAuditRecord'
      }
    }]
  },
  {
    component: Layout,
    path: '/goods',
    meta: {
      title: 'goods', // 商品管理
      icon: 'icon-shangpinguanli',
      code: 'goods'
    },
    children: [{
      path: 'goodsType', // 商品类型
      component: _import('goods/goodsType/index'),
      name: 'goodsType',
      meta: {
        title: 'goodsType',
        icon: '',
        noCache: true,
        code: 'goodsType'
      }
    },
    {
      path: 'goodsCombination', // 商品组合
      component: _import('goods/goodsCombination/index'),
      name: 'goodsCombination',
      meta: {
        title: 'goodsCombination',
        icon: '',
        noCache: true,
        code: 'goodsCombination'
      }
    }]
  },
  {
    component: Layout,
    path: '/public',
    meta: {
      title: 'public', // 公共模块
      icon: 'icon-gongzhongmokuai',
      code: 'public'
    },
    children: [{
      path: 'publicLesson', // 推荐课程
      component: _import('public/publicLesson/index'),
      name: 'publicLesson',
      meta: {
        title: 'publicLesson',
        icon: '',
        noCache: true,
        code: 'publicLesson'
      }
    }, {
      path: 'publicMessage', // 通知公告
      component: _import('public/publicMessage/index'),
      name: 'publicMessage',
      meta: {
        title: 'publicMessage',
        icon: '',
        noCache: true,
        code: 'publicMessage'
      }
    }, {
      path: 'notice', // 通知公告
      component: _import('public/notice/index'),
      name: 'notice',
      meta: {
        title: 'notice',
        icon: '',
        noCache: true,
        code: 'notice'
      }
    }

    // {
    //   path: 'publicAuditRecord', // 通知审核
    //   component: _import('public/publicAuditRecord/index'),
    //   name: 'publicAuditRecord',
    //   meta: {
    //     title: 'publicAuditRecord',
    //     icon: 'icon-jixieshebei',
    //     noCache: true,
    //     code: 'publicAuditRecord'
    //   }
    // }
    ]
  },
  /**
   * 广告管理
   */
  {
    component: Layout,
    path: '/adManage',
    meta: {
      title: 'adManage',
      icon: 'icon-guanggaoguanli',
      code: 'adManage'
    },
    children: [{
      path: 'adManage', // 学员信息
      component: _import('adManage/index'),
      name: 'adManage',
      meta: {
        title: 'adManage',
        icon: '',
        noCache: true,
        code: 'adManage'
      }
    }]
  },
  /**
   * 学员管理
   */
  {
    component: Layout,
    path: '/memberManage',
    meta: {
      title: 'memberManage',
      icon: 'icon-xueyuanguanli',
      code: 'memberManage'
    },
    children: [{
      path: 'member', // 学员信息
      component: _import('memberManage/member/index'),
      name: 'member',
      meta: {
        title: 'member',
        icon: '',
        noCache: true,
        code: 'member'
      }
    }]
  },
  /**
   * 财务管理
   */
  {
    component: Layout,
    path: '/financeManage',
    meta: {
      title: 'financeManage',
      icon: 'icon-caiwuguanli',
      code: 'financeManage'
    },
    children: [{
      path: 'payment', // 缴费记录
      component: _import('financeManage/payment/index'),
      name: 'payment',
      meta: {
        title: 'payment',
        icon: '',
        noCache: true,
        code: 'payment'
      }
    }, {
      path: 'commission', // 提成比例
      component: _import('financeManage/commission/index'),
      name: 'commission',
      meta: {
        title: 'commission',
        icon: '',
        noCache: true,
        code: 'commission'
      }
    }, {
      path: 'order', // 订单记录
      component: _import('financeManage/order/index'),
      name: 'order',
      meta: {
        title: 'order',
        icon: '',
        noCache: true,
        code: 'order'
      }
    }, {
      path: 'settlement', // 结算管理
      component: _import('financeManage/settlement/index'),
      name: 'settlement',
      meta: {
        title: 'settlement',
        icon: '',
        noCache: true,
        code: 'settlement'
      }
    }]
  },
  /**
   * 企业管理
   */
  {
    component: Layout,
    path: '/enterpriseManage',
    meta: {
      title: 'enterpriseManage',
      icon: 'icon-qiyeguanli1',
      code: 'enterpriseManage'
    },
    children: [{
      path: 'enterprise', // 企业管理
      component: _import('enterpriseManage/enterprise/index'),
      name: 'enterprise',
      meta: {
        title: 'enterprise',
        icon: '',
        noCache: true,
        code: 'enterprise'
      }
    }]
  },
  /**
   * 教育培训
   */
  {
    component: Layout,
    path: '/training',
    meta: {
      title: 'training',
      icon: 'icon-jiaoyupeixun',
      code: 'training'
    },
    children: [{
      path: 'questionLib', // 代理商题库管理
      component: _import('training/questionLib/index'),
      name: 'questionLib',
      meta: {
        title: 'questionLib',
        icon: '',
        noCache: true,
        code: 'questionLib'
      }
    },
    {
      path: 'paper', // 试卷管理
      component: _import('training/paper/index'),
      name: 'paper',
      meta: {
        title: 'paper',
        icon: '',
        noCache: true,
        code: 'paper'
      }
    },
    {
      path: 'special', // 专题
      component: _import('training/special/index'),
      name: 'special',
      meta: {
        title: 'special',
        icon: '',
        noCache: true,
        code: 'special'
      }
    }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js